// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1UaOd","Logo":"Toolbar_Logo__2k832","DesktopOnly":"Toolbar_DesktopOnly__19vtD"};